app.factory('treatmentCostSimulationService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function TreatmentCostSimulationService() {

            this.get = function(visitCardId) {
                return baseService.get(config.API_URL + '/treatmentCostSimulations/' + visitCardId).then(
                    function(successResponse) {
                        if (_.isEmpty(successResponse)) {
                            return successResponse;
                        }

                        var data = objectHelper.translateObject(successResponse, TreatmentCostSimulationVO);
                        //data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.suggest = function(visitCardId, simulation) {
                return baseService.post(config.API_URL + '/treatmentCostSimulations/' + visitCardId, simulation).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TreatmentCostSimulationVO);
                        //data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.run = function (simulation) {
                return  baseService.put(config.API_URL + '/treatmentCostSimulations/', simulation).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, TreatmentCostSimulationVO);
                        //data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.addToDataSet = function (simulation) {
                return  baseService.post(config.API_URL + '/treatmentCostSimulations/dataSet', simulation).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new TreatmentCostSimulationService();
    }
]);
